<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    stroke="currentColor"
    fill="currentColor"
  >
    <g>
      <path
        d="M370.4,364.8c-2.6,4.3-7.2,6.8-12.2,6.8H142.1c-5,0-9.6-2.5-12.2-6.8c-2.6-4.3-2.9-9.5-0.6-13.9l107.8-215.3
		c2.5-4.9,7.3-7.9,12.8-7.9h0c5.5,0,10.3,2.9,12.8,7.9L371,350.9C373.2,355.3,373,360.6,370.4,364.8 M378.3,347.2L270,131.9
		c-3.8-7.6-11.6-12.4-20.1-12.4h0c-8.6,0-16.3,4.8-20.1,12.4L121.9,347.2c-3.5,7-3.2,15.2,1,21.9c4.1,6.7,11.3,10.7,19.2,10.7h216.1
		c7.9,0,15-4,19.2-10.7C381.4,362.4,381.8,354.2,378.3,347.2"
      />
      <path
        d="M217.2,270.4l43.5-39.8l-13.7,33c-1.3,3.1,0.2,6.7,3.3,8l23.2,9.6c0.9,0.4,1.2,1.1,1.2,1.5
		c0.1,0.4,0.1,1.2-0.6,1.9l-43.5,39.8l13.7-33c1.3-3.1-0.2-6.7-3.3-8l-23.2-9.6c-0.9-0.4-1.2-1.1-1.2-1.5
		C216.5,271.9,216.5,271.1,217.2,270.4 M208.5,273.7c0.6,3.5,2.9,6.3,6.2,7.7l21.3,8.8l-16.4,39.6c-1.1,2.7-0.2,5.7,2.1,7.4
		c1.1,0.8,2.3,1.1,3.5,1.1c1.5,0,3-0.5,4.1-1.6l50.3-46.1c2.6-2.4,3.8-5.9,3.2-9.3c-0.6-3.5-2.9-6.3-6.2-7.7l-21.3-8.8l16.4-39.6
		c1.1-2.7,0.2-5.7-2.1-7.4c-2.4-1.7-5.5-1.5-7.7,0.5l-50.3,46.1C209.1,266.8,207.9,270.3,208.5,273.7"
      />
      <path
        d="M148.7,353.2l101.2-202.1l101.6,202.1H148.7z M255.4,143.8c-1-2.1-3.1-3.4-5.5-3.4h0c-2.3,0-4.4,1.3-5.5,3.4
		L139.9,352.5c-1,1.9-0.9,4.2,0.3,6c1.1,1.8,3.1,2.9,5.2,2.9h209.5c2.1,0,4.1-1.1,5.2-2.9c1.1-1.8,1.2-4.1,0.3-6L255.4,143.8z"
      />
    </g>
  </svg>
</template>
